import ContactControl from "./contact/ContactControl";
import ProjectControl from "./build/projects/ProjectControl";
import Header from "./Header";
import { Switch, Route, useLocation } from "react-router-dom";
import PricingControl from "./pricing/PricingControl";

function Control() {
  const location = useLocation();
  return (
    <>
      <Header />

      <Switch location={location} key={location.pathname}>
        <Route path="/contacts">
          <ContactControl />
        </Route>

        <Route path="/build">
          <ProjectControl />
        </Route>
        <Route path="/pricing">
          <PricingControl />
        </Route>
        <Route path="/">
          <ContactControl />
        </Route>
      </Switch>
    </>
  );
}

export default Control;
